import { restartGame } from '../Game/Game';
import React, { useState } from 'react';
import styled from 'styled-components';

interface IRestartButton {
  selectedPlayer: number | null;
}

const StyledButton = styled.div<{}>`
  background-color: magenta;
  width: 200px;
  border-radius: 50px;
  margin: 20px 10px 10px 10px;
  border: solid black 3px;
  cursor: pointer;
`;

const ConfirmationOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConfirmationBox = styled.div`
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
`;

export default function RestartButton(props: IRestartButton) {
  const { selectedPlayer } = props;
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleConfirmRestart = () => {
    restartGame();
    setShowConfirmation(false);
  };

  let button = <div></div>;

  button = (
    <>
      <StyledButton onClick={() => setShowConfirmation(true)}>
        {'Click me to restart game!'}
      </StyledButton>
      {showConfirmation && (
        <ConfirmationOverlay>
          <ConfirmationBox>
            <p>
              Are you sure you want to restart the game? All tokens will be
              moved to their yard.
            </p>
            <button onClick={handleConfirmRestart}>Yes</button>
            <button onClick={() => setShowConfirmation(false)}>Cancel</button>
          </ConfirmationBox>
        </ConfirmationOverlay>
      )}
    </>
  );

  if (selectedPlayer !== null) {
    return button;
  } else {
    return <div></div>;
  }
}
